"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETCH_REWARD_BARCODE_DATA = exports.GET_HOMEPAGE_REWARDS = exports.GET_COUPONS = exports.GET_COUPON = exports.NEXT_PAGE = exports.RESET = exports.GET_REWARD_LIST_V2 = exports.GET_REWARD_FEATURED = exports.CLAIM_FREE_ENTRY = exports.FETCH_FREE_ENTRIES = exports.FETCH_ENTRIES = exports.REDEEM_REWARD = exports.GET_ALL_DRAWS = exports.GET_ACTIVE_DRAW = exports.GET_REWARD_WITH_FREQUENCY_CAP = exports.RESET_REWARD = exports.GET_REWARD = exports.GET_REWARD_LIST = exports.RewardType = void 0;
var RewardType;
(function (RewardType) {
    RewardType["CODE"] = "CODE";
    RewardType["COUPON"] = "COUPON";
    RewardType["DRAW"] = "DRAW";
    RewardType["EXTERNAL"] = "EXTERNAL";
    RewardType["SWEEPSTAKES"] = "SWEEPSTAKES";
    RewardType["GAMEPLAY"] = "GAMEPLAY";
    RewardType["STANDARD"] = "STANDARD";
})(RewardType || (exports.RewardType = RewardType = {}));
const GET_REWARD_LIST = 'reward/GET_REWARD_LIST';
exports.GET_REWARD_LIST = GET_REWARD_LIST;
const GET_REWARD_LIST_V2 = 'reward/GET_REWARD_LIST_V2';
exports.GET_REWARD_LIST_V2 = GET_REWARD_LIST_V2;
const GET_REWARD_FEATURED = 'reward/GET_REWARD_FEATURED';
exports.GET_REWARD_FEATURED = GET_REWARD_FEATURED;
const GET_REWARD = 'reward/GET_REWARD';
exports.GET_REWARD = GET_REWARD;
const RESET_REWARD = 'reward/RESET_REWARD';
exports.RESET_REWARD = RESET_REWARD;
const RESET = 'reward/RESET';
exports.RESET = RESET;
const GET_REWARD_WITH_FREQUENCY_CAP = 'reward/GET_REWARD_WITH_FREQUENCY_CAP';
exports.GET_REWARD_WITH_FREQUENCY_CAP = GET_REWARD_WITH_FREQUENCY_CAP;
const GET_ACTIVE_DRAW = 'reward/GET_ACTIVE_DRAW';
exports.GET_ACTIVE_DRAW = GET_ACTIVE_DRAW;
const GET_ALL_DRAWS = 'reward/GET_ALL_DRAWS';
exports.GET_ALL_DRAWS = GET_ALL_DRAWS;
const REDEEM_REWARD = 'reward/REDEEM_REWARD';
exports.REDEEM_REWARD = REDEEM_REWARD;
const FETCH_FREE_ENTRIES = 'reward/FETCH_FREE_ENTRIES';
exports.FETCH_FREE_ENTRIES = FETCH_FREE_ENTRIES;
const FETCH_ENTRIES = 'reward/FETCH_ENTRIES';
exports.FETCH_ENTRIES = FETCH_ENTRIES;
const CLAIM_FREE_ENTRY = 'reward/CLAIM_FREE_ENTRY';
exports.CLAIM_FREE_ENTRY = CLAIM_FREE_ENTRY;
const FETCH_REWARD_BARCODE_DATA = 'reward/FETCH_BARCODE_DATA';
exports.FETCH_REWARD_BARCODE_DATA = FETCH_REWARD_BARCODE_DATA;
const NEXT_PAGE = 'reward/NEXT_PAGE';
exports.NEXT_PAGE = NEXT_PAGE;
const GET_COUPON = 'reward/GET_COUPON';
exports.GET_COUPON = GET_COUPON;
const GET_COUPONS = 'reward/GET_COUPONS';
exports.GET_COUPONS = GET_COUPONS;
const GET_HOMEPAGE_REWARDS = 'reward/GET_HOMEPAGE_REWARDS';
exports.GET_HOMEPAGE_REWARDS = GET_HOMEPAGE_REWARDS;
//# sourceMappingURL=types.js.map